import React, { useState } from 'react';
import {
  Input,
  Button,
  Row,
  Col,
  Checkbox,
  Typography,
  Space,
  Card,
} from 'antd';
import {
  DeleteOutlined,
  CopyOutlined,
  EditOutlined,
  PlusOutlined,
  SaveOutlined,
} from '@ant-design/icons';

import styled from 'styled-components';

import Section from './Section';

const { Title, Text, Link } = Typography;

const Group = ({ group, onDelete, onDuplicate, onChange, editable }) => {
  const [title, setTitle] = useState(group.title);

  const handleSectionChange = (sectionIdx, field, idx, value) => {
    const newSections = group.sections.map((section, i) => {
      if (i !== sectionIdx) return section;
      if (field === 'checkboxes') {
        const newCheckboxes = [...section.checkboxes];
        newCheckboxes[idx] = value;
        return { ...section, checkboxes: newCheckboxes };
      }
      if (field === 'checkboxLabels') {
        return { ...section, checkboxLabels: value };
      }
      if (field === 'checkboxLabelsAndImportant') {
        return {
          ...section,
          checkboxLabels: value.labels,
          checkboxImportant: value.important,
        };
      }
      if (field === 'checkboxImportant') {
        return { ...section, checkboxImportant: value };
      }
      return { ...section, [field]: value };
    });
    onChange({ ...group, sections: newSections });
  };

  const addSection = () => {
    const newSection = {
      id: Date.now(),
      checkboxes: [false, false, false, false],
      description: '',
      freeText: '',
    };
    onChange({ ...group, sections: [...group.sections, newSection] });
  };

  const deleteSection = (index) => {
    onChange({
      ...group,
      sections: group.sections.filter((_, i) => i !== index),
    });
  };

  const duplicateSection = (index) => {
    const sec = group.sections[index];
    const newSection = {
      ...sec,
      id: Date.now(),
    };
    onChange({
      ...group,
      sections: [
        ...group.sections.slice(0, index + 1),
        newSection,
        ...group.sections.slice(index + 1),
      ],
    });
  };

  const handleTitleChange = (e) => {
    setTitle(e.target.value);
    onChange({ ...group, title: e.target.value });
  };

  return (
    <Card
      style={{
        marginBottom: 24,
        width: '100%',
        boxSizing: 'border-box',
        padding: '0',
      }}
      bodyStyle={{ padding: 0 }}
      title={
        <Input
          value={title}
          onChange={handleTitleChange}
          style={{
            width: '100%',
            fontSize: 18,
          }}
          disabled={!editable}
        />
      }
      extra={
        <Space>
          <Button
            icon={<DeleteOutlined />}
            danger
            type="text"
            onClick={onDelete}
            disabled={!editable}
            style={{ paddingLeft: 8, paddingRight: 0 }}
          >
            Delete
          </Button>
          <Button
            icon={<CopyOutlined />}
            onClick={onDuplicate}
            disabled={!editable}
            type="text"
            style={{ color: '#1677ff', paddingLeft: 8, paddingRight: 0 }}
          >
            Duplicate
          </Button>
        </Space>
      }
    >
      <div style={{ padding: 18 }}>
        {group.sections.map((section, idx) => (
          <Section
            key={section.id}
            section={section}
            onDelete={() => deleteSection(idx)}
            onDuplicate={() => duplicateSection(idx)}
            onChange={(field, i, value) =>
              handleSectionChange(idx, field, i, value)
            }
            editable={editable}
          />
        ))}
        <Button
          type="dashed"
          block
          icon={<PlusOutlined />}
          onClick={addSection}
          style={{ marginTop: 8, color: '#1677ff' }}
          disabled={!editable}
        >
          Add New Section
        </Button>
      </div>
    </Card>
  );
};

export default Group;
